export const iconFontAwesomeEnergyBatteryQuarter = (
	<i className="fa-solid fa-battery-quarter"></i>
);
